<div class="col-md-12 no-padding animated fadeIn">
  <h3>Opções para Beneficiários/Atendidos:</h3>
  <hr>

  <button class="btn btn-app animated fadeInDown" routerLinkActive="btn-app-active" [routerLink]="['listar']"
    pTooltip="Listar beneficiários" tooltipPosition="top">
    <i class="fa fa-list"></i> Listar
  </button>

  <button class="btn btn-app animated fadeInDown" routerLinkActive="btn-app-active" [routerLink]="['novo']"
    pTooltip="Cadastro de novo beneficiário" tooltipPosition="top">
    <i class="fa fa-users"></i> Casdastrar
  </button>

  <div class="col-md-12 no-padding">
    <hr>
  </div>

</div>

<div class="col-md-12">
  <router-outlet></router-outlet>
</div>